module.exports = __webpack_public_path__ + "img/selected5-min.7f7547a8.png";